import React from "react";
import { motion } from "framer-motion";
import { FaQuoteLeft } from "react-icons/fa";
import SitePicture from "../SitePicture";

function FounderSection() {
  return (
    <section id="founder-section" className="scroll-mt-36 py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid md:grid-cols-5 gap-8 md:gap-12 items-center"
        >
          <div className="md:col-span-2 flex justify-center">
            <div className="relative">
              <div className="absolute -inset-3 rounded-3xl bg-brand-yellow rotate-3" aria-hidden="true" />
              <SitePicture
                name="about/founder"
                alt="Mr. Rajendra C. Bidave, founder"
                sizes="300px"
                className="relative w-64 sm:w-72 h-auto rounded-2xl object-cover shadow-xl"
              />
            </div>
          </div>
          <div className="md:col-span-3">
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-brand-navy-light">
              Founder
            </span>
            <h2 className="mt-2 text-3xl sm:text-4xl font-bold text-brand-navy">Mr. Rajendra C. Bidave</h2>
            <div className="mt-4 h-1 w-16 rounded-full bg-brand-yellow" />
            <blockquote className="relative mt-6 rounded-2xl bg-brand-navy p-6 sm:p-8 text-white shadow-xl">
              <FaQuoteLeft className="absolute -top-4 left-6 text-3xl text-brand-yellow" aria-hidden="true" />
              <p className="text-base sm:text-lg leading-relaxed">
                Mr. Rajendra C. Bidave is the founder of the "Bidave Group" & he is the key
                person of the said "Bidave Group." He has 26 years of rich
                experience in Civil Construction work and is having a 'Trusted Name'
                in the industry.
              </p>
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default FounderSection;
